import { useEffect, useState, useRef } from "react";
import CooldownSpinner from "../../components/CooldownSpinner/CooldownSpinner";
import MqttService from "../../services/MqttService";
import { AccessIcons } from "../../utils/accessIcons";
import { publish } from "../../utils/events";
import './AccessButton.css';
import { clamp } from "../../utils/math";

const DEBOUNCE_TIME = 3000;

export function AccessButton({ access, token, userLocation, updateInvitation, ...props }) {
   const [waitingDebounce, setWaitingDebounce] = useState(false);
   const intervalRef = useRef(null);

   useEffect(() => {
      function onMouseUp() {
         if (!intervalRef.current) return;
         clearInterval(intervalRef.current);
         setWaitingDebounce(false);
         intervalRef.current = null;
      }
      document.addEventListener("mouseup", onMouseUp);
      document.addEventListener("touchend", onMouseUp);
      return () => {
         document.removeEventListener("mouseup", onMouseUp);
         document.removeEventListener("touchend", onMouseUp);
      }
   }, []);

   function startCooldown(waitTime, startTime, action) {
      if (intervalRef.current) clearInterval(intervalRef.current);
      intervalRef.current = setInterval(() => {
         if ((Date.now() - startTime) >= waitTime) {
            clearInterval(intervalRef.current);
            setWaitingDebounce(false);
            intervalRef.current = null;
            action();
            return;
         }
         publish(`accessButtonCooldown-${access.moduleId}-${access.accessIndex}`, clamp(0, Infinity, ((Date.now() - startTime) / waitTime)));
      }, 1);
   }

   async function sendInvitationCommand(data) {
      setWaitingDebounce(true);
      startCooldown(DEBOUNCE_TIME, Date.now(), async () => {
         const response = await MqttService.sendInvitationCommand({
            origin: "frontEnd",
            content: {
               invitationToken: token,
               userLocation: userLocation ? `${userLocation.latitude},${userLocation.longitude}` : null,
               id_access: data.moduleId,
               access_index: data.accessIndex,
               direction: 1,
               operator: `Convidado`,
            },
            action: "sendCommand",
         });
         if (response.status === 200) {
            updateInvitation(prev => ({ ...prev, credits: prev.credits - 1 }));
         }
      });
   }

   return (
      <button
         disabled={props.disabled}
         type="button"
         onTouchStart={e => sendInvitationCommand({ moduleId: access.moduleId, accessIndex: access.accessIndex, })}
         onMouseDown={e => sendInvitationCommand({ moduleId: access.moduleId, accessIndex: access.accessIndex, })}
         className={`access-button select-none! flex disabled:cursor-not-allowed disabled:opacity-[.6]! flex-row cursor-pointer hover:opacity-[.6]! duration-150 items-center min-h-[100px]! justify-center gap-2 text-white text-center! bg-(--primaryColor) rounded-[8px]! p-3! ${waitingDebounce ? 'waiting-debounce' : ''
            }`}
      >
         <CooldownSpinner
            id={`accessButtonCooldown-${access.moduleId}-${access.accessIndex}`}
            cooldownTime={DEBOUNCE_TIME}
            style={{ position: 'absolute' }}
         />
         <div>
            <span className="text-2xl! leading-none!">
               {AccessIcons[access.type]}
            </span>
            <span className="font-medium text-[16px]!">{access.name}</span>
         </div>
      </button>
   );
}